var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _g2, _path14;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAero(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aero",
    xmlns: "http://www.w3.org/2000/svg",
    width: 70.78,
    height: 70.775,
    viewBox: "0 0 70.78 70.775",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2380",
    "data-name": "Path 2380",
    d: "M345.332,128.4l10.907,36.616-2.629,2.629L332.867,139.3Zm0,0",
    transform: "translate(-286.601 -110.487)",
    fill: "#fcfcff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2381",
    "data-name": "Path 2381",
    d: "M160.815,337.784l-3.9-10.127-6.232,6.232L157.7,340.9Zm0,0",
    transform: "translate(-129.82 -282.323)",
    fill: "#fcfcff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2384",
    "data-name": "Path 2384",
    d: "M136.558,19.747,99.942,8.84l-2.629,2.629L125.65,32.212Zm0,0",
    transform: "translate(-83.686 -7.699)",
    fill: "#fcfcff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2385",
    "data-name": "Path 2385",
    d: "M91.178,287.8l10.128,3.9-6.232,6.232-7.012-7.012Zm0,0",
    transform: "translate(-75.86 -248.02)",
    fill: "#fcfcff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2386",
    "data-name": "Path 2386",
    d: "M183.465,8.91c-2.824-2.824-9.349,1.558-14.023,6.233-14.023,14.023-35.837,40.511-35.837,40.511l3.116,3.116s26.488-21.814,40.511-35.837c4.674-4.674,9.057-11.2,6.232-14.023Zm0,0",
    transform: "translate(-114.606 -6.99)",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2387",
    "data-name": "Path 2387",
    d: "M188.351,9.406a2.962,2.962,0,0,0-1.529-.813c.669,3.24-3.083,8.532-7.045,12.494-14.023,14.023-40.511,35.837-40.511,35.837l.784.784,1.558,1.558S168.1,37.453,182.119,23.429c4.674-4.674,9.057-11.2,6.232-14.023Zm0,0",
    transform: "translate(-119.492 -7.486)",
    fill: "#c5c5ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2388",
    "data-name": "Path 2388",
    d: "M136.365,44.108l2-2a3.237,3.237,0,0,0-4.085-4.982l-.422-1.418,2.17-2.17a3.235,3.235,0,0,0-4.261-4.85L129.2,20.051c1.027-.989,2.01-1.951,2.937-2.878a34.2,34.2,0,0,0,6.116-7.962c2.15-4.163,1.25-6.388.117-7.522s-3.359-2.033-7.522.117a34.172,34.172,0,0,0-7.961,6.116c-.927.927-1.89,1.91-2.878,2.937l-8.632-2.571a3.235,3.235,0,0,0-4.85-4.261l-2.17,2.17-1.418-.422a3.237,3.237,0,0,0-4.981-4.085l-2,2L85.737.651a1.033,1.033,0,0,0-1.025.26L82.082,3.54A1.043,1.043,0,0,0,82.2,5.1l25.772,18.864c-5.811,6.552-11.409,13.112-15.361,17.8l-7.581-2.916a1.033,1.033,0,0,0-1.1.234L80.816,42.2a1.033,1.033,0,0,0,0,1.46L96.4,59.242a1.043,1.043,0,0,0,1.461,0l3.116-3.116a1.033,1.033,0,0,0,.234-1.1l-2.915-7.58c4.687-3.952,11.246-9.55,17.8-15.361l2.047,2.8a1.033,1.033,0,0,0,1.667-1.22L117.641,30.7c3.426-3.058,6.81-6.144,9.88-9.051l9.731,32.669-1.342,1.342L122.535,37.391a1.033,1.033,0,1,0-1.667,1.22l14.087,19.245a1.043,1.043,0,0,0,1.564.12l2.629-2.629a1.033,1.033,0,0,0,.26-1.025ZM107.986,5.487a1.171,1.171,0,0,1,1.655,1.655l-.484.484-2.551-.76ZM99.416,3.15a1.171,1.171,0,1,1,1.655,1.655l-.319.318L98.2,4.364Zm-15.022,1,1.342-1.342,32.669,9.731c-2.907,3.07-5.993,6.454-9.051,9.88Zm.524,36.872,6.289,2.419c-1.577,1.878-2.787,3.332-3.5,4.192l-4.7-4.7ZM89.174,49.1c3.6-4.344,22.633-27.176,35.172-39.716a32.561,32.561,0,0,1,7.449-5.74c1.686-.871,3.942-1.664,5.113-.492s.379,3.427-.492,5.113a32.577,32.577,0,0,1-5.741,7.449C118.138,28.251,95.305,47.284,90.961,50.885Zm9.865,6.042-1.911,1.911-4.7-4.7c.86-.713,2.314-1.923,4.192-3.5Zm36.214-16.153a1.171,1.171,0,1,1,1.655,1.655l-1.214,1.214-.76-2.551Zm-2.337-8.57a1.171,1.171,0,0,1,1.655,1.655l-1.38,1.38-.76-2.551Zm0,0",
    transform: "translate(-68.78 -0.499)",
    fill: "#3335cf"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2389",
    "data-name": "Path 2389",
    d: "M395.6,433.3l-8.814,8.814a1.033,1.033,0,1,0,1.461,1.461l8.814-8.814A1.033,1.033,0,0,0,395.6,433.3Zm0,0",
    transform: "translate(-332.883 -373.094)",
    fill: "#ff7b00"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2390",
    "data-name": "Path 2390",
    d: "M385.7,402.551a1.033,1.033,0,0,0-1.46-1.46l-5.509,5.508a1.033,1.033,0,1,0,1.461,1.461Zm0,0",
    transform: "translate(-326.057 -345.296)",
    fill: "#ff7b00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2391",
    "data-name": "Path 2391",
    d: "M371.974,362.294a1.033,1.033,0,1,0-1.461-1.461l-3.856,3.856a1.033,1.033,0,0,0,1.461,1.461Zm0,0",
    transform: "translate(-315.665 -310.713)",
    fill: "#ff7b00"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2392",
    "data-name": "Path 2392",
    d: "M10.577,50.859a1.034,1.034,0,0,0-1.461,0L.3,59.674a1.032,1.032,0,0,0,0,1.46,1.044,1.044,0,0,0,1.461,0l8.814-8.814a1.034,1.034,0,0,0,0-1.461Zm0,0",
    transform: "translate(0.001 -43.707)",
    fill: "#ff7b00"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2393",
    "data-name": "Path 2393",
    d: "M63.653,83.063a1.032,1.032,0,0,0-1.46,0l-5.509,5.509a1.033,1.033,0,1,0,1.46,1.46l5.509-5.508a1.033,1.033,0,0,0,0-1.461Zm0,0",
    transform: "translate(-48.668 -71.375)",
    fill: "#ff7b00"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2394",
    "data-name": "Path 2394",
    d: "M109,112.535a1.044,1.044,0,0,0,1.461,0l3.856-3.856a1.033,1.033,0,1,0-1.461-1.461L109,111.074A1.034,1.034,0,0,0,109,112.535Zm0,0",
    transform: "translate(-93.653 -92.191)",
    fill: "#ff7b00"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2471",
    "data-name": "Group 2471",
    transform: "translate(48.698 1.439)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2374",
    "data-name": "Path 2374",
    d: "M207.789,26.794a2.089,2.089,0,1,1,2.089-2.088A2.091,2.091,0,0,1,207.789,26.794Zm0-2.6a.509.509,0,1,0,.509.509A.51.51,0,0,0,207.789,24.2Z",
    transform: "translate(-205.701 -22.617)",
    fill: "#c5c5ff"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_2472",
    "data-name": "Group 2472",
    transform: "translate(41.253 63.249)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2374-2",
    "data-name": "Path 2374",
    d: "M207.789,26.794a2.089,2.089,0,1,1,2.089-2.088A2.091,2.091,0,0,1,207.789,26.794Zm0-2.6a.509.509,0,1,0,.509.509A.51.51,0,0,0,207.789,24.2Z",
    transform: "translate(-205.701 -22.617)",
    fill: "#c5c5ff"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2395",
    "data-name": "Path 2395",
    d: "M19.586,140.1a1.31,1.31,0,0,0,1.31-1.31v-1.31h1.31a1.31,1.31,0,1,0,0-2.62H20.9v-1.31a1.31,1.31,0,1,0-2.62,0v1.31h-1.31a1.31,1.31,0,1,0,0,2.62h1.31v1.31A1.31,1.31,0,0,0,19.586,140.1Z",
    transform: "translate(-8.478 -109.721)",
    fill: "#c5c5ff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAero);
export default __webpack_public_path__ + "static/media/aero.c86135a18686ec5c82af6722e15d1c82.svg";
export { ForwardRef as ReactComponent };